export const LOGIN_LISTEN = "login/LOGIN_LISTEN"
export const LOGIN_SUCCESS = "login/LOGIN_SUCCESS"